import React from 'react';
import { ButtonProps } from '@mui/material';
import { Button, ButtonIntent } from '../Button/Button';
import { useTheme } from '../../hooks/ThemeProvider';
import './ActionButton.scss';

interface ActionButtonProps extends Omit<ButtonProps, 'variant' | 'size'> {
  variant?: 'primary' | 'info' | 'success' | 'warning' | 'error';
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
  className?: string;
}

// Map old variants to new intents
const variantToIntent: Record<string, ButtonIntent> = {
  primary: 'primary',
  info: 'secondary',
  success: 'success',
  warning: 'warning',
  error: 'danger',
};

/**
 * @deprecated Use the new Button component directly instead
 * This component exists for backwards compatibility
 */
export const ActionButton: React.FC<ActionButtonProps> = ({
  variant = 'primary',
  size = 'medium',
  fullWidth = false,
  className = '',
  children,
  ...rest
}) => {
  const { isDarkMode } = useTheme();

  const intent = variantToIntent[variant] || 'primary';

  return (
    <Button
      intent={intent as ButtonIntent}
      size={size}
      fullWidth={fullWidth}
      className={`action-button action-button--${variant} action-button--${size} ${isDarkMode ? 'action-button--dark' : 'action-button--light'} ${className}`}
      {...rest}
    >
      {children}
    </Button>
  );
};
